export default __webpack_public_path__ + "static/media/demonguardian.07df2fef.png";